var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.279999 10.991C0.233332 10.9459 0.233334 10.9009 0.233334 10.8559C0.186666 10.8108 0.140001 10.7207 0.140001 10.6757C0.140001 10.6306 0.0933361 10.5856 0.0933361 10.4955C0.0933361 10.4504 0.0466652 10.3604 0.0466652 10.3153C0.0466652 10.2252 0 10.1351 0 10.045C0 10 0 10 0 9.95495C0 9.90991 0 9.90991 0 9.86487C0 9.77477 0 9.68468 0.0466652 9.59459C0.0466652 9.5045 0.0933361 9.45946 0.0933361 9.41441C0.0933361 9.36937 0.140001 9.32432 0.140001 9.27928C0.186668 9.18919 0.233332 9.14414 0.279999 9.05405C0.279999 9.00901 0.326668 9.00901 0.326668 8.96396C0.420002 8.87387 0.466669 8.78378 0.560001 8.69369L9.00667 0.540541C9.75333 -0.18018 10.92 -0.18018 11.6667 0.540541C12.4133 1.26126 12.4133 2.38739 11.6667 3.10811L6.39334 8.1982H26.1333C27.16 8.1982 28 9.00901 28 10C28 10.991 27.16 11.8018 26.1333 11.8018H6.39334L11.6667 16.8919C12.4133 17.6126 12.4133 18.7387 11.6667 19.4595C11.2933 19.8198 10.8267 20 10.36 20C9.89333 20 9.42667 19.8198 9.05333 19.4595L0.560001 11.2613C0.466669 11.1712 0.373333 11.0811 0.279999 10.991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.ce505560be71e6c08dbdfab52246a2a0.svg";
export { ForwardRef as ReactComponent };